<script>
import Screen from "@/components/illustrations/Screen";
import WorkHeader from "@/components/headers/WorkHeader";

export default {
  name: "Work",
  components: {
    Screen,
    WorkHeader
  }
};
</script>

<template>
  <div>
    <work-header />
    <main>
      <section>
        <h2>Research</h2>
        <article>
          <div class="content">
            <h3>{{ $t("creations[0].title") }}</h3>
            <p>{{ $t("creations[0].description") }}</p>
          </div>
          <div class="screen-container">
            <screen class="illustration" />
            <img
              alt=""
              src="https://gitlab.com/mai-public1/assets/-/raw/master/quickstreet.jpg"
            />
          </div>
        </article>
        <article>
          <div class="content">
            <h3>{{ $t("creations[1].title") }}</h3>
            <p>{{ $t("creations[1].description") }}</p>
          </div>
          <div class="screen-container">
            <screen class="illustration" />
            <img
              alt=""
              src="https://gitlab.com/mai-public1/assets/-/raw/master/restaurant.png"
            />
          </div>
        </article>
        <article>
          <div class="content">
            <h3>{{ $t("creations[2].title") }}</h3>
            <p>{{ $t("creations[2].description") }}</p>
          </div>
          <div class="screen-container">
            <screen class="illustration" />
            <img alt="" src="https://infinitycards.us/social-image.png" />
          </div>
        </article>
      </section>
      <section>
        <h2>UX Design</h2>
        <article>
          <div class="content">
            <h3>{{ $t("creations[0].title") }}</h3>
            <p>{{ $t("creations[0].description") }}</p>
          </div>
          <div class="screen-container">
            <screen class="illustration" />
            <img
              alt=""
              src="https://gitlab.com/mai-public1/assets/-/raw/master/quickstreet.jpg"
            />
          </div>
        </article>
        <article>
          <div class="content">
            <h3>{{ $t("creations[1].title") }}</h3>
            <p>{{ $t("creations[1].description") }}</p>
          </div>
          <div class="screen-container">
            <screen class="illustration" />
            <img
              alt=""
              src="https://gitlab.com/mai-public1/assets/-/raw/master/restaurant.png"
            />
          </div>
        </article>
        <article>
          <div class="content">
            <h3>{{ $t("creations[2].title") }}</h3>
            <p>{{ $t("creations[2].description") }}</p>
          </div>
          <div class="screen-container">
            <screen class="illustration" />
            <img alt="" src="https://infinitycards.us/social-image.png" />
          </div>
        </article>
      </section>
      <section>
        <h2>Illustrations</h2>
        <div class="illustration-container">
          <img src="https://via.placeholder.com/350x250" alt="" />
          <img src="https://via.placeholder.com/350x250" alt="" />
          <img src="https://via.placeholder.com/350x250" alt="" />
          <img src="https://via.placeholder.com/350x250" alt="" />
        </div>
      </section>
    </main>
    <footer-social />
  </div>
</template>

<style lang="scss">
.illustration-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  img {
    padding: 40px 10px;
  }
}
</style>
